import React, {memo, useEffect, useRef} from "react";
import {getTimeOfMessage} from "../../pages/root/helpers";

const ChatMessage = ({user, userFrom, msg, onViewed}) => {
    const {data, timestamp} = msg;
    const sent = userFrom.CustID === user.CustID

    const messageClass = sent ? 'sent' : 'received';
    const authorName = userFrom ? userFrom.FirstName + " " + userFrom.LastName : 'Unknown user'
    const divRef = useRef(null)

    useEffect(() => {
        onViewed && !msg.viewed && !sent && onViewed(msg.id)
    }, [])

    // const isInViewport = (offset = 0) => {
    //     const elem = divRef.current
    //     const top = elem.parentElement.getBoundingClientRect().top;
    //     console.log(elem);
    //     console.log(elem.parentElement.getBoundingClientRect());
    //     console.log('off', offset);
    //     console.log(window.innerHeight);
    //     console.log('top', top)
    //
    //     return (top + offset) >= 0 && (top - offset) <= window.innerHeight;
    // };
    //
    // useEffect(() => {
    //     if(divRef && divRef.current)
    //         console.log(data, isInViewport(offset))
    // }, [divRef])


    return (<>
        <div ref={divRef} className={`message-chat ${messageClass}`}>
            <div style={{flexDirection: 'column', textAlign: 'left'}}>
                <div style={{display: 'inline-flex', fontWeight: 900, fontSize: '1.1vw', alignItems: 'baseline'}}>
                    {authorName}
                    <div style={{ marginLeft: "10px", fontSize: "0.8em", fontWeight: '300'}}>
                        {getTimeOfMessage(timestamp)}
                    </div>
                </div>
                <div style={{fontWeight: 400, color: '#c0c0c0'}}>{data}</div>
            </div>
        </div>
    </>)
};




export default memo(ChatMessage)